// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"f6ddc5b37c1f42d63f0c","966":"da135b622b824b611fe9"}[chunkId] + ".js";
};